import { render, staticRenderFns } from "./CreateTestTicket.vue?vue&type=template&id=15a9f752&scoped=true"
import script from "./CreateTestTicket.vue?vue&type=script&lang=js"
export * from "./CreateTestTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateTestTicket.vue?vue&type=style&index=0&id=15a9f752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9f752",
  null
  
)

export default component.exports